var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoyado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.7,39.8c-3.3-1.9-6.2-4.7-8.1-8.1c-2-3.4-3-7.4-3-11.4c0-6-5-11.1-11.2-11.1C13,9.2,8.5,13,7.4,18 c-1.9,7.1,1.4,17.9,5.8,25.3c0.5,0.9,1,1.7,1.5,2.4c4,6,9.3,12,16.3,14.4c0.6,0.3,1.1,0.4,1.8,0.5c0.8,0.1,1.5,0.3,2.3,0.3 c3.8,0,7.6-2,9.7-5.6C47.9,49.9,46.1,43,40.7,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,31.7c6.2,0,11.2-5.1,11.2-11.2S58.2,9.2,52,9.2s-11.2,5.1-11.2,11.2S45.8,31.7,52,31.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoyado);
export default __webpack_public_path__ + "static/media/voyado.dd28936606eea37f9374a1dcef8bbeda.svg";
export { ForwardRef as ReactComponent };